import { useEffect } from "react";
import SectionHeader from "@/components/SectionHeader";
import CourseCard from "@/components/CourseCard";
import ComparisonTable from "@/components/ComparisonTable";
import FinalCTA from "@/components/FinalCTA";
import { Reveal } from "@/components/Reveal";
import { COURSES } from "@/data/content";

const Courses = () => {
  useEffect(() => {
    document.title = "Courses — Stock Market, Forex & Advanced Trading | T Plus One";
  }, []);

  return (
    <main className="pt-32 lg:pt-40">
      <header className="container-x pb-16 lg:pb-24" data-testid="courses-header">
        <Reveal><p className="eyebrow">Courses</p></Reveal>
        <Reveal delay={0.1}>
          <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.08] max-w-3xl">
            Structured programs for every stage of the journey.
          </h1>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-xl text-base sm:text-lg text-dim leading-relaxed">
            Three 3-month programs — Indian markets, Forex and advanced trading — available online and offline, each with lifetime Premium Community access.
          </p>
        </Reveal>
      </header>

      <section className="container-x pb-24">
        <div className="grid md:grid-cols-3 gap-5">
          {COURSES.map((c, i) => <CourseCard key={c.slug} course={c} index={i} />)}
        </div>
      </section>

      <section className="py-24 lg:py-32 bg-white border-t border-line" data-testid="courses-comparison">
        <div className="container-x">
          <SectionHeader eyebrow="Compare" lines={["Find your fit."]} sub="Same philosophy, same duration, same lifetime community access — different markets and depth." />
          <div className="mt-14">
            <ComparisonTable />
          </div>
        </div>
      </section>

      <FinalCTA />
    </main>
  );
};

export default Courses;
